import createIcon from '../../createIcon';

/**
 * @component @name Fivek
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMSAxMC41SDhWMTEuNUgxMEMxMC41NSAxMS41IDExIDExLjk1IDExIDEyLjVWMTRDMTEgMTQuNTUgMTAuNTUgMTUgMTAgMTVINi41VjEzLjVIOS41VjEyLjVINi41VjlIMTFWMTAuNVpNMTggMTVIMTYuMjVMMTQuNSAxMi43NVYxNUgxM1Y5SDE0LjVWMTEuMjVMMTYuMjUgOUgxOEwxNS43NSAxMkwxOCAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fivek = createIcon('Fivek', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM11 10.5H8V11.5H10C10.55 11.5 11 11.95 11 12.5V14C11 14.55 10.55 15 10 15H6.5V13.5H9.5V12.5H6.5V9H11V10.5ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z',
      key: '1vvyvy',
    },
  ],
]);

export default Fivek;
